import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

import { QuestionnaireImportance } from "../../Questionnaire/enum/QuestionnaireImportance.enum";

const { REQUIRED, ACCEPT_TERMS } = ERROR_TYPE;

export const RegisterSchema = z
	.object({
		firstName: z.string().min(2, { message: REQUIRED }),
		lastName: z.string().min(2, { message: REQUIRED }),
		email: z.string().min(1, { message: REQUIRED }).email(),
		companyName: z.string().min(1, { message: REQUIRED }),
		privacyStatement: z.boolean(),
	})
	.superRefine(({ privacyStatement }, ctx) => {
		if (!privacyStatement) {
			ctx.addIssue({
				code: "custom",
				path: ["privacyStatement"],
				message: ACCEPT_TERMS,
			});
		}
	});

export const RegisterRequestSchema = z.object({
	firstName: z.string().min(2, { message: REQUIRED }),
	lastName: z.string().min(2, { message: REQUIRED }),
	email: z.string().min(1, { message: REQUIRED }).email(),
	companyName: z.string().min(1, { message: REQUIRED }),
	privacyStatement: z.boolean(),
	importance: z.nativeEnum(QuestionnaireImportance),
});

export type RegisterType = z.infer<typeof RegisterSchema>;
export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;
